import React from "react";
import DSSButton from "../../../../ui/building-blocks/atoms/dss-button";
import './footer-layout.scss';

interface SupportedBrowsersModalProps {
  onClose: () => void;
}

const SupportedBrowsersModal: React.FC<SupportedBrowsersModalProps> = ({ onClose }) => {
  return (
    <div className="privacy-modal-content">
      <div className="privacy-modal-title">Supported Browsers</div>
      <div className="privacy-modal-body">
        INDS can be better viewed using the following browsers:
        <ul className="privacy-modal-title" style={{ marginTop: 8, marginLeft: 18 }}>
          <li>Microsoft Edge</li>
          <li>Mozilla Firefox</li>
          <li>Chrome</li>
        </ul>
        <div style={{ marginTop: 12 }}>
          If you have issues with your browser, switch to any of these.
        </div>
      </div>
      <div style={{ textAlign: "right", marginTop: 24 }}>
        <DSSButton variant="secondary" onClick={onClose} id="supported-browsers-close">
          Close
        </DSSButton>
      </div>
    </div>
  );
};

export default SupportedBrowsersModal;